import { ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SupportService } from 'SupportApp/services/support.service';
import * as i0 from "@angular/core";
import * as i1 from "SupportApp/services/support.service";
import * as i2 from "@angular/platform-browser";
import * as i3 from "@angular/common";
import * as i4 from "../contact-page/support-contact-info-page.component";
import * as i5 from "../support-sidebar/support-sidebar.component";
function SupportCategoryPageComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "div", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 7)(5, "strong", 9);
    i0.ɵɵtext(6, " Questions? ");
    i0.ɵɵelementStart(7, "a", 10);
    i0.ɵɵtext(8, "Contact Us!");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.pageName);
} }
function SupportCategoryPageComponent_div_5_ycn_support_sidebar_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-support-sidebar", 17);
    i0.ɵɵtwoWayListener("selectedContentIdChange", function SupportCategoryPageComponent_div_5_ycn_support_sidebar_1_Template_ycn_support_sidebar_selectedContentIdChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r0.activeContentId, $event) || (ctx_r0.activeContentId = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("selectedCategoryChange", function SupportCategoryPageComponent_div_5_ycn_support_sidebar_1_Template_ycn_support_sidebar_selectedCategoryChange_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.updateActiveCategoryOnClick($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectedCategory", ctx_r0.activeCategory);
    i0.ɵɵtwoWayProperty("selectedContentId", ctx_r0.activeContentId);
    i0.ɵɵproperty("categories", ctx_r0.categories);
} }
function SupportCategoryPageComponent_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.activeCategory == null ? null : ctx_r0.activeCategory.sanitized_upsell_html, i0.ɵɵsanitizeHtml);
} }
function SupportCategoryPageComponent_div_5_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21)(2, "div", 22);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 23);
    i0.ɵɵelement(5, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "hr", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const content_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", i0.ɵɵinterpolate(content_r3.slug));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", content_r3.title, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", content_r3.sanitized_body, i0.ɵɵsanitizeHtml);
} }
function SupportCategoryPageComponent_div_5_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SupportCategoryPageComponent_div_5_ng_container_6_div_1_Template, 7, 4, "div", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.activeContentList);
} }
function SupportCategoryPageComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, SupportCategoryPageComponent_div_5_ycn_support_sidebar_1_Template, 1, 3, "ycn-support-sidebar", 12);
    i0.ɵɵelementStart(2, "div", 13)(3, "div", 14);
    i0.ɵɵelement(4, "ycn-support-contact-info-page");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SupportCategoryPageComponent_div_5_div_5_Template, 1, 1, "div", 15)(6, SupportCategoryPageComponent_div_5_ng_container_6_Template, 2, 1, "ng-container", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.activeCategory);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", !(ctx_r0.contactCategory && ctx_r0.contactCategory.id === (ctx_r0.activeCategory == null ? null : ctx_r0.activeCategory.id)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r0.activeCategory == null ? null : ctx_r0.activeCategory.user_has_access));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.activeCategory == null ? null : ctx_r0.activeCategory.user_has_access) && (!ctx_r0.contactCategory || ctx_r0.contactCategory.id !== (ctx_r0.contactCategory == null ? null : ctx_r0.contactCategory.id)));
} }
export class SupportCategoryPageComponent {
    constructor(supportService, eltRef, sanitizer) {
        this.supportService = supportService;
        this.eltRef = eltRef;
        this.sanitizer = sanitizer;
        this.loading = true;
        this.categories = [];
        this.activeContentList = [];
        this.pageName = this.eltRef.nativeElement.getAttribute('pageName');
        // prevent browsers previous scroll position on refresh to favour hash positiion
        window.history.scrollRestoration = 'manual';
    }
    ngOnInit() {
        this.fetchCategory();
    }
    updateActiveCategoryOnClick(category) {
        this.activeCategory = category;
        this.getCategoryClosestContent();
        this.updateActiveContentList();
        if (this.activeCategory.content.length > 0) {
            this.activeContentId = this.activeCategory.content[0].id;
        }
        window.scrollTo(0, 0);
    }
    updateActiveContent(contentId) {
        if (this.activeContentList.length === 0) {
            return;
        }
        const newContentId = contentId || this.activeContentList[0].id;
        if (this.activeContentId === newContentId) {
            this.activeContentId = -1;
        }
        else {
            this.activeContentId = newContentId;
        }
    }
    getCategoryClosestContent() {
        if (this.activeCategory) {
            if (this.activeCategory.content.length === 0 && this.activeCategory.sub_categories.length > 0) {
                this.activeCategory = { ...this.activeCategory.sub_categories[0] };
            }
        }
    }
    updateActiveContentList() {
        if (!this.activeCategory) {
            return;
        }
        this.activeContentList = this.activeCategory.content.map((content) => ({
            ...content,
            sanitized_body: this.sanitizer.bypassSecurityTrustHtml(content.body),
        }));
    }
    fetchCategory() {
        this.supportService.getPageCategories(this.pageName).subscribe((responseData) => {
            this.pageName = responseData.page;
            this.categories = responseData.categories.map((category) => this.prepareCategory(category));
            // Contact Information category needs unique content.
            this.contactCategory = responseData.categories.find((category) => category.name === 'Contact Information');
            const hash = decodeURIComponent(window.location.hash.replace('#', ''));
            const foundHasnInCategoryOrContent = hash ? this.initializeFromCategoryLocationHash(hash) : false;
            if (!foundHasnInCategoryOrContent) {
                this.initializeFromEmptyHash();
            }
            this.loading = false;
        });
    }
    initializeFromCategoryLocationHash(hash) {
        this.activeContentId = -1;
        const foundCategory = this.searchCategoryByHash(hash, this.categories);
        if (foundCategory) {
            this.activeCategory = foundCategory;
            this.getCategoryClosestContent();
            this.updateActiveContentList();
            if (this.activeCategory.content.length > 0 && this.activeContentId === -1) {
                this.activeContentId = this.activeCategory.content[0].id;
            }
            setTimeout(() => {
                const elToScrollTo = document.getElementById(hash);
                if (elToScrollTo) {
                    elToScrollTo.scrollIntoView();
                }
            });
            return true;
        }
        return false;
    }
    initializeFromEmptyHash() {
        [this.activeCategory] = this.categories;
        this.getCategoryClosestContent();
        this.updateActiveContentList();
        if (this.activeContentList.length > 0) {
            this.activeContentId = this.activeContentList[0].id;
        }
    }
    searchCategoryByHash(hash, categories) {
        let foundCategory;
        for (let i = 0; i < categories.length; i += 1) {
            const category = categories[i];
            if (category.internal_name === hash) {
                foundCategory = category;
                break;
            }
            const foundHashInContent = category.content.find((content) => content.slug === hash);
            if (foundHashInContent) {
                this.activeContentId = foundHashInContent.id;
                foundCategory = category;
                break;
            }
            foundCategory = this.searchCategoryByHash(hash, category.sub_categories);
            if (foundCategory) {
                break;
            }
        }
        return foundCategory;
    }
    prepareCategory(category) {
        return {
            ...category,
            sanitized_upsell_html: this.sanitizer.bypassSecurityTrustHtml(category.upsell_html),
            sub_categories: category.sub_categories.map((sub_category) => this.prepareCategory(sub_category)),
        };
    }
}
SupportCategoryPageComponent.ɵfac = function SupportCategoryPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SupportCategoryPageComponent)(i0.ɵɵdirectiveInject(i1.SupportService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.DomSanitizer)); };
SupportCategoryPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SupportCategoryPageComponent, selectors: [["ycn-support-category-page"]], standalone: false, decls: 6, vars: 2, consts: [[1, "page", "page-support"], [1, "page-header", "page-header-support", "page-header-tall"], [1, "container"], ["class", "row", 4, "ngIf"], [1, "page-body", "container"], ["class", "row wide-gutters", 4, "ngIf"], [1, "row"], [1, "col-auto"], [1, "page-title"], [1, "page-header-sidebar"], ["href", "/sales_support/contact", 1, "text-blue"], [1, "row", "wide-gutters"], ["class", "tabs tabs-vertical col-3", 3, "selectedCategory", "selectedContentId", "categories", "selectedContentIdChange", "selectedCategoryChange", 4, "ngIf"], [1, "tab-content", "col-8", "col-lg-9"], [3, "hidden"], [3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [1, "tabs", "tabs-vertical", "col-3", 3, "selectedContentIdChange", "selectedCategoryChange", "selectedCategory", "selectedContentId", "categories"], [3, "innerHTML"], ["class", "tab-pane active", 4, "ngFor", "ngForOf"], [1, "tab-pane", "active"], [1, "topics-section"], [1, "topics-section-header", 3, "id"], [1, "topics-section-body"], [1, "divider-horizontal", "mt-3", "mb-3"]], template: function SupportCategoryPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, SupportCategoryPageComponent_div_3_Template, 9, 1, "div", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, SupportCategoryPageComponent_div_5_Template, 7, 4, "div", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.SupportContactInfoPageComponent, i5.SupportSidebarComponent], encapsulation: 2 });
